import {
  createOverlay,
  type BaseOverlay,
  type BaseOverlayOptions,
  createBaseOverlay,
} from '@/shared/lib'

export type RoomCountOverlayProps = Omit<BaseOverlayOptions, 'map' | 'position'>

type RoomCountOverlayOptions = BaseOverlayOptions & RoomCountOverlayProps

export type RoomCountOverlay = BaseOverlay

export const createRoomCountOverlay = () => {
  const BaseOverlay = createBaseOverlay()

  const RoomCountOverlay = createOverlay<
    RoomCountOverlay,
    RoomCountOverlayOptions
  >({
    base: BaseOverlay,
  })

  return RoomCountOverlay
}
